import { render } from "./ModalAdv.vue?vue&type=template&id=196f8a40"
import script from "./ModalAdv.vue?vue&type=script&lang=js"
export * from "./ModalAdv.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__